// extracted by mini-css-extract-plugin
module.exports = {"entered":"transition-scrollScreenshotTransitionNext-module--entered--11B6B","exiting":"transition-scrollScreenshotTransitionNext-module--exiting--2SUxg"};